<template>
  <div class="my-5 mx-2 px-0">
    <!-- <v-flex xs4 sm4 md4 mb-3>
    </v-flex>-->
    <v-stepper v-model="e1" class="elevation-0 mx-0">
      <!-- <v-divider class="mx-4"></v-divider> -->
      <v-stepper-header class="elevation-0 px-4 mb-0 pb-0">
        <!-- <v-divider></v-divider> -->
        <v-stepper-step :complete="e1 > 1" step="1"
          >Select Artist</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">Basic Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3"
          >Artwork Details</v-stepper-step
        >
        <!-- <v-divider></v-divider> -->
        <!-- <v-stepper-step step="3">Photos</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">Actions</v-stepper-step>-->
      </v-stepper-header>
      <!-- <v-divider class="mx-4"></v-divider> -->

      <v-stepper-items class="mx-0">
        <v-stepper-content step="1">
          <v-card class="mb-4 elevation-0 mx-0">
            <v-card-title class="headline font-weight-medium pl-4"
              >Add Artwork {{ artwork.title.toUpperCase() }} to
              Collection/Commission</v-card-title
            >

            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <!-- <v-btn color="success" @click="reloadArtists">reload</v-btn> -->
                  <v-autocomplete
                    item-text="name"
                    item-value="id"
                    label="Select Artist"
                    :items="artists"
                    v-model="artwork.artist_id"
                    @input="getArtist(artwork.artist_id)"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>

            <div v-if="processedArtist" class="ml-3">
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{ processedArtist.name }}</h3>
                  <div>
                    <span v-if="processedArtist.birth_date"
                      >Birthdate: {{ processedArtist.birth_date }}<br
                    /></span>
                    <span v-if="processedArtist.birthplace"
                      >Birth place: {{ processedArtist.birthplace }}<br
                    /></span>
                    <span v-if="processedArtist.bio"
                      >Bio: {{ processedArtist.bio }}<br
                    /></span>
                    <!-- Artworks: {{processedArtist.artworks}}<br> -->
                  </div>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-checkbox
                  class="ml-2"
                  label="Yes, this is the one"
                  color="black"
                  v-model="approved"
                ></v-checkbox>
              </v-card-actions>
            </div>
          </v-card>

          <v-btn
            :disabled="!approved || !processedArtist"
            color="black"
            class="mr-4 mb-3 right white--text"
            @click.native="e1 = 2"
            >Next</v-btn
          >
          <v-btn outline @click="$router.go(-1)" class="ml-4 mb-3"
            >Cancel</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="2" class="mb-2 mt-0 pt-0">
          <v-card color="white" class="mb-2 elevation-0 mt-0 pt-0">
            <v-container px-0>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container grid-list-xs px-0 mx-0 xs12>
                    <v-layout row wrap>
                      <!-- title -->
                      <v-flex xs12>
                        <v-text-field
                          required
                          v-model="artwork.title"
                          label="Title *"
                        ></v-text-field>
                      </v-flex>

                      <!-- Type of Work -->
                      <v-flex xs12>
                        <v-select
                          @change="get_all_an"
                          required
                          v-model="artwork.type_of_work_id"
                          label="Type of Work *"
                          :items="constants['TYPES_OF_WORK']"
                          item-value="id"
                          item-text="name"
                          class="ml-1"
                        ></v-select>
                        <v-flex v-if="artwork.type_of_work_id == '3'">
                          <v-radio-group
                            v-model="artwork.film_type"
                            label="Select Film Type"
                            row
                          >
                            <v-radio
                              v-for="s in ['tape', 'film', 'digital born']"
                              :label="s"
                              :value="s"
                              color="black"
                              :key="s"
                              class="ml-3"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>

                        <v-flex
                          v-if="artwork.type_of_work_id == '6'"
                          class="xs12 mx-3 mb-5"
                        >
                          <v-flex class="xs12 mx-3">
                            <v-flex class="subheadline mt-4">Includes</v-flex>
                            <!-- <v-checkbox
                              v-for="s in [
                                'Objects',
                                'Sound',
                                'FilmVideoAV',
                                'Slide',
                                'Computer Program / Software / File',
                                'Performance',
                                'Light',
                                'Other',
                              ]"
                              v-model="artwork.instalation_includes"
                              :key="s"
                              :label="s"
                              :value="s"
                              hide-details
                              xs12
                              md6
                              color="black"
                              lg4
                              dense
                            ></v-checkbox> -->
                            <!-- @change="saveSubfield(s.field, f_artwork[s.field])" -->
                            <v-checkbox
                              v-for="s in this.$store.state.includes"
                              :key="s.field"
                              v-model="artwork[s.field]"
                              :label="s.title"
                              :false-value="0"
                              :true-value="1"
                              hide-details
                              color="black"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>

                          <v-flex
                            v-if="
                              artwork.instalation_includes.indexOf(
                                'FilmVideoAV'
                              ) >= 0
                            "
                            class="xs12 mx-3"
                          >
                            <v-radio-group
                              v-model="artwork.film_type"
                              label="Select Film Type"
                              row
                            >
                              <v-radio
                                v-for="s in ['tape', 'film', 'digital born']"
                                :label="s"
                                :value="s"
                                :key="s"
                                color="black"
                                class="ml-3"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>

                          <v-flex
                            v-if="
                              artwork.instalation_includes.indexOf('Other') >= 0
                            "
                            class="xs12 mx-3"
                          >
                            <v-text-field
                              v-model="artwork.instalation_includes_other"
                              class="ml-3"
                              name="including_other"
                              label="Other"
                              row
                            ></v-text-field>
                          </v-flex>
                        </v-flex>
                      </v-flex>

                      <!-- channels -->
                      <v-flex
                        v-if="
                          artwork.type_of_work_id == '7' ||
                          (artwork.type_of_work_id == '6' &&
                            this.artwork.including_film == '1')
                        "
                      >
                        <v-select
                          v-model="artwork.fvs_channel_id"
                          :items="this.constants.CHANNELS"
                          item-value="id"
                          item-text="name"
                          label="Channels"
                          class="ml-0"
                        ></v-select>
                      </v-flex>
                      <!-- <v-radio-group
                          @change="change_an"
                          v-model="artwork.acquired"
                          required
                          
                          label
                        >
                          <v-radio
                            v-for="o in [
                              {
                                id: 'nontba',
                                value: 'nontba',
                                name: 'Non-TBA',
                              },
                              {
                                id: 'commission',
                                value: 'commission',
                                name: 'Commission',
                              },
                              {
                                id: 'acquired',
                                value: 'acquired',
                                name: 'Acquired',
                              },
                            ]"
                            :label="o.name"
                            :value="o.id"
                            :key="o.id"
                            class="ml-1"
                            color="black"
                          ></v-radio>
                        </v-radio-group> -->
                      <!-- <v-btn-toggle
                          class="ml-0"
                          v-model="artwork.acquisition_method"
                        >
                          <v-btn
                            small
                            flat
                            v-for="s in this.constants.ACQUISITION_METHODS"
                            :key="s.id ? s.value : s"
                            class="px-2"
                            :value="s.id"
                          >
                            <span>{{ s.name }}</span>
                          </v-btn>
                        </v-btn-toggle> -->

                      <!-- Ownership Status/Acquired -->
                      <v-flex xs12 mb-3 mt-3>
                        <h3 class="body-2 ml-1 pb-2 grey--text text--darken-1">
                          Ownership Status
                        </h3>

                        <!-- @change="change_an" -->
                        <v-btn-toggle
                          @change="get_all_an"
                          v-model="artwork.acquired"
                          required
                          small
                        >
                          <v-btn
                            flat
                            small
                            v-for="o in [
                              {
                                id: 'nontba',
                                value: 'nontba',
                                name: 'Non-TBA',
                              },
                              {
                                id: 'commission',
                                value: 'commission',
                                name: 'Commission',
                              },
                              {
                                id: 'acquired',
                                value: 'acquired',
                                name: 'Acquired',
                              },
                              {
                                id: 'com_academy',
                                value: 'com_academy',
                                name: 'TBA21-Academy Commission',
                              },
                            ]"
                            :label="o.name"
                            :value="o.id"
                            :key="o.id"
                            class="ml-1"
                            color="black"
                          >
                            {{ o.name }}
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>

                      <!-- Ownership -->
                      <v-flex
                        xs12
                        md6
                        mt-3
                        grey--text
                        text--darken-1
                        v-if="artwork.acquired == 'acquired'"
                      >
                        <h3 class="body-2 ml-1">Ownership</h3>
                        <v-radio-group
                          @change="get_all_an"
                          required
                          v-model="artwork.ownership"
                          column
                          label
                        >
                          <v-radio
                            v-for="o in constants.OWNERSHIPS"
                            :label="o.name"
                            :value="o.id"
                            :key="o.id"
                            class="ml-1"
                            color="black"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>

                <!-- <v-btn
            color="black"
            class="ml-3 black--text"
            :disabled="!isValid"
            outline
            small
            @click.native="saveAndAddAnother"
            >Save and add another Artwork</v-btn
          > -->
                <!-- <v-btn flat>Cancel</v-btn> -->
              </v-card-text>
            </v-container>
          </v-card>

          <v-divider class="mx-4"></v-divider>

          <v-layout row wrap px-0 mx-4>
            <v-flex text-xs-left xs2>
              <v-btn outline @click="$router.go(-1)" class="ml-0 mb-3"
                >Cancel</v-btn
              >
            </v-flex>
            <v-flex class="text-xs-center pt-3 xs8">
              <span v-if="!isValid"
                >Title and Type of Work must be filled in !</span
              >
            </v-flex>
            <v-flex text-xs-right xs2>
              <v-btn
                :disabled="!isValid"
                color="black"
                class="mr-0 mb-3 white--text"
                @click.native="e1 = 3"
                >Next</v-btn
              >
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card color="white" class="mb-2 elevation-0 mt-0 pt-0">
            <v-container px-0>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container grid-list-xs px-0 mx-0 xs12>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pr-3 grid>
                        <!-- {{changed_an}}- {{this.artwork.accession_number}} -->
                        <!-- :value="changed_an" -->
                        <v-text-field
                          required
                          v-model="artwork.accession_number"
                          label="Accession Number"
                          @keyup="check_an($event.target.value)"
                        >
                          <template v-slot:append-outer>
                            <v-menu offset-x>
                              <v-btn
                                color="primary"
                                small
                                dark
                                icon
                                slot="activator"
                              >
                                <v-icon small>menu</v-icon>
                              </v-btn>
                              <v-list>
                                <v-list-tile
                                  v-for="(item, i) in all_an_limited"
                                  :key="item + i"
                                >
                                  <v-list-tile-title>{{
                                    item
                                  }}</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </template>
                        </v-text-field>
                        <div class="red--text" v-if="an_exists">
                          This accession number already exists!
                        </div>
                        <!-- {{ get_all_an().reverse() }} -->
                      </v-flex>
                      <v-flex xs12 sm6>
                        <!-- type="number"
                          mask="####" -->
                        <v-text-field
                          required
                          v-model.number="artwork.production_date_new"
                          label="Production Year"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          required
                          rows="1"
                          auto-grow
                          v-model="artwork.credit"
                          label="Credit"
                        ></v-textarea>
                      </v-flex>
                      <!-- <v-flex xs12>
                                <h3 class="body-2">Old Classification</h3>
                                <v-radio-group required v-model="artwork.classification" row label="">
                                  <v-radio label="PPPD" value="pppd" class="ml-4" ></v-radio>
                                  <v-radio label="IAO" value="iao"></v-radio>
                                  <v-radio label="FURN" value="furn"></v-radio>
                                  <v-radio label="FVS" value="fvs"></v-radio>
                                  <v-radio label="ARCH" value="arch"></v-radio>
                                </v-radio-group>
                      </v-flex>-->
                      <v-flex
                        xs12
                        md6
                        v-if="
                          artwork.acquired != 'com_academy' &&
                          artwork.acquired != 'commission' &&
                          artwork.acquired != 'nontba'
                        "
                      >
                        <h3 class="body-2 ml-1">Acquisition Method</h3>
                        <v-radio-group
                          required
                          v-model="artwork.acquisition_method"
                          column
                          label
                        >
                          <v-radio
                            v-for="o in this.constants.ACQUISITION_METHODS"
                            :label="o.name"
                            :value="o.id"
                            :key="o.id"
                            class="ml-1"
                            color="black"
                          ></v-radio>
                        </v-radio-group>

                        <!-- <v-btn-toggle
                          class="ml-0"
                          v-model="artwork.acquisition_method"
                        >
                          <v-btn
                            small
                            flat
                            v-for="s in this.constants.ACQUISITION_METHODS"
                            :key="s.id ? s.value : s"
                            class="px-2"
                            :value="s.id"
                          >
                            <span>{{ s.name }}</span>
                          </v-btn>
                        </v-btn-toggle> -->
                      </v-flex>

                      <v-flex xs12>
                        <v-textarea
                          rows="1"
                          auto-grow
                          v-model="artwork.media_material_description"
                          label="Media Material Description"
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <v-autocomplete
                          label="Location"
                          v-model="artwork.artwork_location_id"
                          :items="locations"
                          item-value="id"
                          item-text="name"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-menu
                          v-model="menu2"
                          :disabled="!c_user.edit"
                          :return-value.sync="artwork.initial_change_date"
                          ref="menu2"
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          landscape
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            v-model="artwork.initial_change_date"
                            slot="activator"
                            label="Location Change Date"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker
                            color="black"
                            persistent
                            v-model="artwork.initial_change_date"
                            @input="
                              $refs.menu2.save(artwork.initial_change_date)
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-container>
          </v-card>

          <v-divider class="mx-4"></v-divider>

          <v-layout row wrap px-0 mx-4>
            <v-flex text-xs-left xs6>
              <v-btn outline @click="e1 = 2" class="ml-0 mb-3">Back</v-btn>
            </v-flex>
            <v-flex text-xs-right xs6>
              <v-btn
                color="black"
                :disabled="!isValid"
                @click.native="saveArtwork(1)"
                class="white--text"
                >Save and Go to Artwork's page</v-btn
              >
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="4">
          <h3 class="title mb-2">
            Please link images from cloud.tba21.org storage to this artwork:
          </h3>
          <v-card color="grey lighten-4" class="mb-5 pl-3 pr-3 pb-3">
            <v-flex xs12 sm12 md12>
              <br />
              <h3 class="title mb-3">
                Select Artist from Cloud TBA21 (Photo station -
                <a href="http://cloud.tba21.org"> <u>cloud.tba21.org</u> </a>)
              </h3>
              <v-autocomplete
                :items="this.$store.state.artists"
                item-value="name"
                item-text="name"
                v-model="cloud_artist_folder_name"
              ></v-autocomplete>
              <h3 v-if="!cloud_artist_folder_name == ''" class="title mb-3">
                Select Artwork
              </h3>
              <v-autocomplete
                v-if="!cloud_artist_folder_name == ''"
                :items="this.$store.state.artworks"
                item-value="title"
                item-text="title"
                v-model="cloud_artwork_folder_name"
              ></v-autocomplete>
            </v-flex>
          </v-card>
          <h3 class="title mb-2">
            No images in for this artwork in cloud yet? Upload temporary and
            link cloud ones later:
          </h3>
          <v-card color="grey lighten-4" class="mb-5 pl-3 pr-3 pb-3">
            <v-flex xs12 sm12 md12>
              <br />
              <h3 class="title mb-3">
                Upload temporary images to "{{ artwork.title }}"
              </h3>
              <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
            </v-flex>
          </v-card>
          <v-btn
            color="black"
            class="ml-2 black--text"
            flat
            @click.native="e1 = 2"
            >Back</v-btn
          >
          <v-btn
            color="black"
            class="ml-3 white--text"
            :disabled="!isValid"
            @click.native="saveArtwork"
            >Save and Continue</v-btn
          >
          <!-- <v-btn flat>Cancel</v-btn> -->
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-card color="grey lighten-4" class="mb-5 pl-3 pr-3 pb-3">
            <v-flex xs12 sm12 md12>
              <br />
              <h3 class="title mb-3">{{ artwork.title }} - Actions</h3>
              <v-btn color="primary" @click.native="pdf">Download PDF</v-btn>
              <v-btn
                color="primary"
                @click="
                  $router.push({
                    path: `/artworks/edit/${artwork.id}`,
                    params: artwork,
                  })
                "
                >Go to Artwork Details Page</v-btn
              >
            </v-flex>
          </v-card>
          <v-btn color="primary" @click.native="e1 = 3">Back</v-btn>
          <!-- <v-btn color="primary" @click.native="e1 = 5">Save</v-btn> -->
          <!-- <v-btn flat >Cancel</v-btn> -->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
// import EditField from '@/components/artworks/EditField'
import axios from 'axios'
import fields from '@/data/full_user_fields'
import constants from '@/data/constants'

function customSort(a, b) {
    var aParts = a.split('.');
    var bParts = b.split('.');
    // console.log(aParts);
    // console.log(bParts);
    
    var aYear = parseInt(aParts[0].split('_')[1]);
    var bYear = parseInt(bParts[0].split('_')[1]);
    // console.log(aYear);
    // console.log(bYear);
    
    var aNum = parseInt(aParts[1]);
    var bNum = parseInt(bParts[1]);
    // console.log(aNum);
    // console.log(bNum);
    
    if (aYear !== bYear) {
        return aYear - bYear;
    }
    
    if (aNum !== bNum) {
        return aNum - bNum;
    }
    
    // If there are additional numbers after the dot, sort them too
    if (aParts.length > 2 && bParts.length > 2) {
        var aExtraNum = parseInt(aParts[2]);
        var bExtraNum = parseInt(bParts[2]);
        
        if (aExtraNum !== bExtraNum) {
            return aExtraNum - bExtraNum;
        }
    }
    
    // If all criteria are the same, maintain original order
    return 0;
}

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  data() {
    return {
      menu2: false,
      change_date: '',
      constants: constants,
      accession_numbers: [],
      // accession_numbers_limited: [],
      processedArtist: '',
      an_exists: false,
      fields: fields,
      valid: true,
      cloud_artwork_folder_name: '',
      cloud_artist_folder_name: '',
      film: {},
      artwork: {
        // id: '',
        // artist_id: '',
        title: '',
        acquired: 'acquired',
        // classification: '',
        initial_change_date: '',
        // change_date: '',
        ownership: '',
        accession_number: '',
        // artwork_location_id: '',
        credit: '',
        // production_date_new: '',
        // accession_date: '',
        // media_material_description: '',
        instalation_includes: [],
        instalation_includes_other: '',
        film_type: '',
      },
      report: {
        date: '',
      },
      success: false,
      menu: false,
      modal: false,
      menu2: false,
      e1: 1,
      autosave: true,
      result: '',
      approved: true,
    }
  },
  // watch: {
  //   artwork (val) {
  //     console.log('WATCH')
  //     this.get_all_an()
  //   }
  // },
  beforeMount() {
    this.$store.dispatch('loadArtworks')
    this.artwork.acquired = 'acquired'
    this.get_all_an()
    this.set_an()
    // this.get_latest_an()
    // this.change_an()
    // this.get_all_an_limited()
  },
  methods: {
    set_an() {
      this.artwork.accession_number = this.changed_an
    },
    get_all_an() {
      // console.log('GET_ALL_AN')
      if (this.artwork.acquired != 'acquired') {
        this.artwork.ownership = ''
      }
      var as = []
      if (this.artwork.acquired === 'acquired') {
        // console.log('ACQUIRED')
        // console.log(this.artwork.ownership)
        // if (this.artwork.ownership === 6) {
        as = this.$store.state.artworks.filter(
          (a) =>
            a.acquired === 'acquired' &&
            a.ownership === this.artwork.ownership &&
            a.accession_number.substring(0, 3) !== 'DEC'
        )
        // } else if (
        //   this.artwork.ownership === 7 ||
        //   this.artwork.ownership === 8
        // ) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 17) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 10) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 11) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       ![6, 7, 8, 10, 11, 17].includes(a.ownership) &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // }
      } else if (this.artwork.acquired === 'commission') {
        as = this.$store.state.artworks.filter(
          (a) => a.acquired === 'commission'
        )
      } else if (this.artwork.acquired === 'nontba') {
        as = this.$store.state.artworks.filter((a) => a.acquired === 'nontba')
      } else if (this.artwork.acquired === 'com_academy') {
        as = this.$store.state.artworks.filter((a) => a.acquired === 'com_academy')
      } else {
        as = this.$store.state.artworks
      }
      // console.log('as')
      // console.log(as)
      this.accession_numbers = as
        .map((a) => a.accession_number)
        .sort(customSort)
        .reverse()
      // console.log('this.accession_numbers')
      // console.log(this.accession_numbers)
      this.set_an()
    },
    reloadArtists() {
      this.artists = Object.assign([], this.$store.state.artists)
    },
    saveAndAddAnother() {
      this.saveArtwork(0)
      this.artwork = {
        title: '',
        instalation_includes: [],
        instalation_includes_other: '',
        film_type: '',
      }
      this.e1 = 1
      // this.$router.push('/artworks/new')
    },
    // saveAndEdit () {
    //   // console.log('saveAndEdit IN')
    //   this.saveArtwork ()
    //   // console.log(this.artwork)
    //   // console.log('saveAndEdit OUT')
    //   this.$router.push({ path:`/artworks/edit/${this.artwork.id}`, artwork: this.artwork})
    // },
    saveArtwork(a) {
      // this.artwork.artwork_location_logs_attributes = [];
      // var artwork_location_log = {};
      this.artwork.created_by = this.c_user.id
      this.artwork.initial_change_date = this.initial_change_date
        ? this.initial_change_date
        : new Date().toISOString().substring(0, 10)

      // artwork_location_log.artwork_id = this.artwork.id;
      // artwork_location_log.storage = "in";
      // artwork_location_log.note = "Created at Artwork record creation in CMS";
      // artwork_location_log.change_date = Date.now;
      // artwork_location_log.artwork_location_id = "";
      // this.artwork.artwork_location_logs_attributes.push(artwork_location_log)

      // console.log('saveArtwork')
      // console.log(this.artwork);
      let url = `${this.$globals.apiserver}/artworks.json`
      axios
        .post(url, { artwork: this.artwork })
        .then((response) => {
          // console.log(response.data);
          this.artwork = response.data

          // var artwork_location_log = {
          //   created_by: this.c_user.id,
          //   storage: 'in',
          //   note: 'Initial Artwork Creation',
          //   change_date: this.initial_change_date ? this.initial_change_date : new Date.now,
          //   copy: 'artwork',
          //   // shipper: '',
          //   // reason: '',
          //   artwork_id: this.artwork.id,
          //   artwork_location_id: this.artwork.artwork_location_id,
          //   // artwork_packing_id: ''
          // }
          // axiosApi
          //   .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
          //     artwork_location_log: artwork_location_log
          //   })
          //   .then(response => {
          //     this.errors = {}
          //     this.artwork.artwork_location_logs.push(response.data)
          //     // if (this.artwork_location_log.copy === 'artwork') {
          //     //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
          //     // } else if (this.artwork_location_log.copy === 'master_physical') {
          //     //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
          //     // } else if (this.artwork_location_log.copy === 'archive_master') {
          //     //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
          //     // } else if (this.artwork_location_log.copy === 'access_copy') {
          //     //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
          //     // }
          //     this.$store.commit('ADD_LOG', response.data)
          //     // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
          //   })
          //   .catch(error => {
          //     // console.log(error)
          //   })

          this.$store.dispatch('addArtwork', response.data)
          this.$store.dispatch('loadArtworks', response.data)
          if (a === 1) {
            // console.log('a === 1 + this.artwork')
            // console.log(this.artwork)
            this.$router.push({
              // path: `/artworks/edit/${this.artwork.id}`,
              name: 'EditArtwork',
              params: { id: this.artwork.id, artwork: this.artwork },
            })
          }
          // this.$store.dispatch('addArtwork',response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
        })
        .catch((error) => {
          // console.log(error)
          // console.log(response.data);
        })
      // }
    },
    check_an(value) {
      // console.log(value)
      // console.log(this.artwork)
      if (value) {
        var a = Object.assign([], this.$store.state.artworks)
        var b = a.filter((aa) => aa.accession_number === value)
        this.an_exists = b.length > 0
      }
    },
    add_field(field) {
      // console.log('this[field]')
      // console.log(field)
      this[field['name']].show = true
    },
    saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTab', tab)
    },
    getArtist(id) {
      // console.log(id);
      let url = `${this.$globals.apiserver}/artists/${id}.json`
      // console.log(url)
      axios
        .get(url)
        .then((response) => {
          // this.loading = false;
          // console.log("this.result");
          // console.log(response.data);
          // console.log(response.data);
          this.result = response.data
          this.processedArtist = response.data
          // this.artwork = response.data
          // this.artist = response.data.artist
          // console.log(this.artwork)
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    clear() {
      this.$refs.form.reset()
    },
    pdf() {
      // download PDF
    },
  },
  computed: {
    changed_an() {
      var no = this.latest_an
      var out = ''
      // console.log('CHANGED_AN')
      if (this.artwork.acquired === 'acquired') {
        if (this.artwork.ownership === 6) {
          out = `D_${new Date().getFullYear()}.${no}`
        } else if (
          this.artwork.ownership === 7 ||
          this.artwork.ownership === 8
        ) {
          out = `E_${new Date().getFullYear()}.${no}`
        } else if (this.artwork.ownership === 17) {
          out = `EH_${new Date().getFullYear()}.${no}`
        } else if (this.artwork.ownership === 10) {
          out = `MR_${new Date().getFullYear()}.${no}`
        } else if (this.artwork.ownership === 11) {
          out = `CA_${new Date().getFullYear()}.${no}`
        } else {
          out = `${new Date().getFullYear()}.${no}`
        }
      } else if (this.artwork.acquired === 'commission') {
        out = `COM_${new Date().getFullYear()}.${no}`
      } else if (this.artwork.acquired === 'nontba') {
        out = `EXH_${new Date().getFullYear()}.${no}`
      } else if (this.artwork.acquired === 'com_academy') {
        out = `COM_${new Date().getFullYear()}.${no}`
      }
      // this.artwork.accession_number = out
      // console.log(this.artwork.accession_number)
      return out
    },
    latest_an() {
      // console.log('LATEST_AN')
      var ans = this.accession_numbers
      // console.log('ans')
      // console.log(ans)
      // var last = ans[ans.length - 1]
      // nacitam posledny artwork
      var last = ans[0]
      // console.log('last')
      // console.log(last)
      var prefix = ''
      var ownership

      // ak user uz zvolil ownership, tak odfiltruj len zvoleny
      if (
        this.artwork.ownership &&
        [6, 7, 10, 11, 17].includes(this.artwork.ownership)
      ) {
        ownership = this.constants.OWNERSHIPS.find(
          (o) => o.id === this.artwork.ownership
        )
        // console.log('ownership')
        // console.log(ownership)
      }
      // pripravim si regex
      prefix = ownership != null ? '(' + ownership.an_ext + '_' + ')' : ''
      var reg = '[A-Z,_]*(\\d*).(.*)'
      // console.log('reg')
      // console.log(reg)

      var r = RegExp(reg)
      var e = r.exec(last)
      // console.log('e')
      // console.log(e)
      // console.log(e[2])
      // console.log(new Date().getFullYear().toString())

      // ak regex nieco nasiel a je to tento rok, tak zvys o 1

      if (e && e[1] === new Date().getFullYear().toString()) {
        var lastNo = e[2]
        var o = (parseInt(lastNo) + 1).toString().padStart(2, 0)
        // console.log('o')
        // console.log(o)
        // INAK JE ASI PRVY V ROKU
      } else {
        var o = '01'
      }
      return o
    },
    all_an_limited() {
      // console.log('ALL_ANN_LIMITED')
      if (this.accession_numbers) {
        // console.log('this.accession_numbers.length')
        // console.log(this.accession_numbers.length)
        // console.log('this.accession_numbers.splice(10, this.accession_numbers.length)')
        // console.log(this.accession_numbers.splice(0, 10))
        return this.accession_numbers.splice(0, 10)
      }
    },
    isValid() {
      return !(
        this.artwork.type_of_work_id === null ||
        this.artwork.type_of_work_id === '' ||
        this.artwork.title === null ||
        this.artwork.title === ''
      )
    },
    locations() {
      var l = Object.assign([], this.$store.getters.enabled_locations)
      return l.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      })
    },
    df() {
      // var c = []
      var fields2 = []
      fields2 = this.fields['tabs']['basic']['fields']
      fields2 = fields2.concat(this.fields['tabs']['advanced']['fields'])
      fields2 = fields2.concat(this.fields['tabs']['acquisition']['fields'])
      // console.log(fields2)
      // c = fields2
      // .filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artwork.classification)))
      // c = c.map(f => f.name)
      return fields2
    },
    // field_list () {
    //   if (!fields['tabs']['acquisition'].component) {
    //     var current_user = { role: 'admin'}
    //     var work_type = 'pppd'
    //     var out = []
    //     var fields2 = fields['tabs']['acquisition']['fields']
    //     // console.log(fields2)
    //     out = fields2.filter((f,i) => f.work_types && f.work_types.includes(this.artwork.classification))
    //     return out
    //   } else {
    //     return []
    //   }
    // },
    // processedArtist () {
    //   return this.result
    // },
    // processedArtist () {
    //   let processedArtist = this.result.artist
    //   return processedArtist
    // },
    artists() {
      var as = Object.assign([], this.$store.state.artists)
      return as.sort(dynamicSort('name'))
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/artworks/AddArtwork.vue